import { SubscriptionAnalyseModal } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/SubscriptionAnalyseModal';
import { useDOCEditSubscriptionAnalyseModal } from './docEditSubscriptionAnalyseModal.hooks';

type DOCSubscriptionAnalyseModalProps = {
  onAnalyseSuccess?: () => void;
};

const DOCSubscriptionAnalyseModal = ({
  onAnalyseSuccess,
}: DOCSubscriptionAnalyseModalProps) => {
  const {
    isSubscriptionAnalyseLoading,
    isSubscriptionMembershipInProgress,
    handleSubmit,
    initialValues,
    handleCancel,
    totalMemberships,
  } = useDOCEditSubscriptionAnalyseModal(onAnalyseSuccess);
  return (
    <SubscriptionAnalyseModal
      isSubscriptionAnalyseLoading={isSubscriptionAnalyseLoading}
      isSubscriptionMembershipInProgress={isSubscriptionMembershipInProgress}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      totalMemberships={totalMemberships}
    />
  );
};

export default DOCSubscriptionAnalyseModal;
